// First touch: the campaign tags on the link a visitor landed on (?utm_source=reddit&…) and the
// host of the site that sent them. Read once as the page loads and sent with the first /me, which
// creates the guest and keeps them; the server ignores them for anyone who already has a session.
// Nothing is stored in the browser.
const TAGS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'] as const

let pending = ''

/** Reads the landing URL's tags, then takes every utm_* out of the address bar. Call before the router starts. */
export function captureFirstTouch() {
  const url = new URL(location.href)
  const touch = new URLSearchParams()
  for (const name of TAGS) {
    const value = url.searchParams.get(name)?.trim()
    if (value) touch.set(name, value.slice(0, 200))
  }
  const ref = referrerHost()
  if (ref) touch.set('ref', ref)
  pending = touch.toString() ? `?${touch}` : ''

  // So a link copied from the address bar doesn't credit the ad.
  const utm = [...url.searchParams.keys()].filter((k) => k.toLowerCase().startsWith('utm_'))
  if (utm.length) {
    for (const k of utm) url.searchParams.delete(k)
    history.replaceState(history.state, '', url.pathname + url.search + url.hash)
  }
}

/** The site that linked here, if it's another one. */
function referrerHost(): string | null {
  try {
    const host = new URL(document.referrer).hostname
    return host && host !== location.hostname ? host : null
  } catch {
    return null
  }
}

/** The query to add to /me until one has gone through. */
export const firstTouchQuery = () => pending
export const firstTouchSent = () => { pending = '' }
